module.exports = __webpack_public_path__ + "img/logo_oncogitiel_white2.9dfb225a.png";